import { render, staticRenderFns } from "./tagRecord.vue?vue&type=template&id=18198d74&scoped=true"
import script from "./tagRecord.vue?vue&type=script&lang=js"
export * from "./tagRecord.vue?vue&type=script&lang=js"
import style0 from "./tagRecord.vue?vue&type=style&index=0&id=18198d74&lang=scss&scoped=true"
import style1 from "./tagRecord.vue?vue&type=style&index=1&id=18198d74&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18198d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18198d74')) {
      api.createRecord('18198d74', component.options)
    } else {
      api.reload('18198d74', component.options)
    }
    module.hot.accept("./tagRecord.vue?vue&type=template&id=18198d74&scoped=true", function () {
      api.rerender('18198d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/orderTag/tagRecord.vue"
export default component.exports